import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/img/icons/moi-operator-tariff.svg'


const _hoisted_1 = { class: "tariff" }
const _hoisted_2 = { class: "tariff-header" }
const _hoisted_3 = { class: "tariff-header__back" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = {
  key: 0,
  class: "tariff-mobile_header"
}
const _hoisted_6 = { class: "h1" }
const _hoisted_7 = {
  key: 1,
  class: "tariff-body"
}
const _hoisted_8 = { class: "tariff-body__header" }
const _hoisted_9 = { class: "tariff-body__header-title" }
const _hoisted_10 = { class: "h1" }
const _hoisted_11 = { class: "tariff-body__header-amount" }
const _hoisted_12 = { class: "caption-medium" }
const _hoisted_13 = { class: "tariff-body__header-amount__old" }
const _hoisted_14 = {
  key: 0,
  class: "tariff-body__header-discount"
}
const _hoisted_15 = { class: "caption-medium color-grey-light" }
const _hoisted_16 = { class: "tariff-body__buttons" }
const _hoisted_17 = {
  href: "/docs/offerte_msc.pdf",
  target: "_blank"
}
const _hoisted_18 = { class: "tariff-body__buttons-item" }
const _hoisted_19 = { class: "button-small" }
const _hoisted_20 = { class: "tariff-body__buttons-item__icon" }
const _hoisted_21 = { class: "button-small" }
const _hoisted_22 = { class: "tariff-body__buttons-item__icon" }
const _hoisted_23 = { class: "tariff-body__amounts" }
const _hoisted_24 = { class: "h2 color-white" }
const _hoisted_25 = {
  key: 0,
  class: "tariff-body__unlimited"
}
const _hoisted_26 = { class: "tariff-body__unlimited-title" }
const _hoisted_27 = { class: "caption-medium--bold" }
const _hoisted_28 = { class: "tariff-body__icons" }
const _hoisted_29 = { class: "tariff-promo" }
const _hoisted_30 = { class: "tariff-change" }
const _hoisted_31 = {
  key: 0,
  class: "tariff-change__item-icon"
}
const _hoisted_32 = { class: "tariff-change__item-title" }
const _hoisted_33 = { class: "caption-large--bold" }
const _hoisted_34 = { class: "tariff-change__item-subtitle" }
const _hoisted_35 = { class: "caption-medium color-text-secondary" }
const _hoisted_36 = { class: "tariff-change__item-counters" }
const _hoisted_37 = { class: "tariff-change__item-counter" }
const _hoisted_38 = { class: "caption-medium--bold color-white" }
const _hoisted_39 = { class: "tariff-change__item-counter" }
const _hoisted_40 = { class: "caption-medium--bold color-white" }
const _hoisted_41 = { class: "tariff-change__item-counter" }
const _hoisted_42 = { class: "caption-medium--bold color-white" }
const _hoisted_43 = {
  key: 1,
  class: "tariff-change__item-unlimited"
}
const _hoisted_44 = { class: "tariff-change__item-unlimited--title" }
const _hoisted_45 = { class: "caption-medium color-text-primary" }
const _hoisted_46 = { class: "tariff-change__item-unlimited--icons" }
const _hoisted_47 = { class: "tariff-change__item-btns" }
const _hoisted_48 = { class: "tariff-change__item-btn" }
const _hoisted_49 = { class: "tariff-change__item-btn" }
const _hoisted_50 = {
  key: 3,
  class: "tariff-details"
}
const _hoisted_51 = { class: "tariff-details__header" }
const _hoisted_52 = { class: "tariff-details__title" }
const _hoisted_53 = { class: "h1" }
const _hoisted_54 = { class: "tariff-details__subtitle" }
const _hoisted_55 = { class: "caption-medium" }
const _hoisted_56 = { class: "tariff-details__amounts" }
const _hoisted_57 = { class: "tariff-details__amounts-item" }
const _hoisted_58 = { class: "h2 color-white" }
const _hoisted_59 = { class: "tariff-details__amounts-item" }
const _hoisted_60 = { class: "h2 color-white" }
const _hoisted_61 = { class: "tariff-details__amounts-item" }
const _hoisted_62 = { class: "h2 color-white" }
const _hoisted_63 = { class: "tariff-details__unlimited" }
const _hoisted_64 = { class: "tariff-details__unlimited--title" }
const _hoisted_65 = { class: "caption-medium color-text-primary" }
const _hoisted_66 = { class: "tariff-details__unlimited--icons" }
const _hoisted_67 = { class: "tariff-details__actions" }
const _hoisted_68 = {
  href: "/docs/offerte_msc.pdf",
  target: "_blank"
}
const _hoisted_69 = { class: "tariff-details__actions-btn" }
const _hoisted_70 = { class: "button-small color-text-primary" }
const _hoisted_71 = { class: "tariff-details__actions-btn__icon" }
const _hoisted_72 = { class: "tariff-details__btn" }

import BaseButton from "@/components/base/BaseButton.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import BasePromocode from "@/components/base/BasePromocode.vue";
import { useTariffPage } from "@/composables/tariff/useTariffPage";
import type { TariffArray } from "@/struct/TariffStruct";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TariffPage',
  setup(__props) {

const {
  changeTariffLaterLoading,
  changeTariffNowLoading,
  chosenTariff,
  closeModals,
  discountAmount,
  discountName,
  doChange,
  formatAmountInput,
  getUnits,
  isChangeTariff,
  isDetailsTariff,
  isSticky,
  mainTariff,
  modalsList,
  pageTitle,
  returnServiceIcons,
  startChange,
  tariffDetails,
  tariffPriceDiscount,
  tariffServices,
  availableTariffs,
  t,
  toPayment,
  updateOffers,
} = useTariffPage();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "account" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(BaseFigureForIcon, {
              size: "medium",
              color: "white",
              icon: "arrow",
              position: "left",
              "is-button": ""
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["tariff-header__title", _unref(isSticky) ? 'visible' : ''])
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(pageTitle)), 1)
      ], 2),
      (_unref(isChangeTariff) || _unref(isDetailsTariff))
        ? (_openBlock(), _createBlock(BaseFigureForIcon, {
            key: 0,
            class: "tariff-header__close",
            icon: "close",
            color: "white",
            size: "medium",
            "is-button": "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
          isChangeTariff.value = false;
          isDetailsTariff.value = false;
        })
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(isChangeTariff) || _unref(isDetailsTariff))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(pageTitle)), 1)
        ]))
      : _createCommentVNode("", true),
    (!_unref(isChangeTariff) && !_unref(isDetailsTariff))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(mainTariff).title), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, [
                (_unref(discountAmount))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(formatAmountInput)(_unref(tariffPriceDiscount))) + " ₽ ", 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formatAmountInput)(_unref(mainTariff).amount)) + " ₽ ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(formatAmountInput)(_unref(mainTariff).amount)) + " ₽ ", 1)
                    ], 64)),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.perMonth")), 1)
              ])
            ]),
            (_unref(discountAmount))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(discountName)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("a", _hoisted_17, [
              _createElementVNode("button", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)("common.labels.offer")), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(BaseIcon, { name: "download" })
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "tariff-body__buttons-item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isChangeTariff.value = true))
            }, [
              _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("tariff.page.change")), 1),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(BaseIcon, { name: "arrow" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainTariff).options, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "tariff-body__amounts-item"
              }, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(item.maximum) + " " + _toDisplayString(_unref(getUnits)(item.id)), 1)
              ]))
            }), 128))
          ]),
          (_unref(tariffServices).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)("tariff.page.unlimited")), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(returnServiceIcons)(_unref(tariffServices)), (img, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "tariff-body__icons-item"
                    }, [
                      _createVNode(BaseIcon, {
                        name: img,
                        folder: "service",
                        "is-original-color": ""
                      }, null, 8, ["name"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(isChangeTariff) && !_unref(isDetailsTariff))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(BasePromocode, { onAction: _unref(updateOffers) }, null, 8, ["onAction"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTariffs), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "tariff-change__item"
              }, [
                (item.operator === 'green')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[5] || (_cache[5] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "operator-icon"
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", _hoisted_33, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("p", _hoisted_35, _toDisplayString(item.renewal_price) + "₽ " + _toDisplayString(_unref(t)("common.labels.perMonth")), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("p", _hoisted_38, _toDisplayString(item.data) + " " + _toDisplayString(_unref(getUnits)("gb")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("p", _hoisted_40, _toDisplayString(item.min) + " " + _toDisplayString(_unref(getUnits)("min")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("p", _hoisted_42, _toDisplayString(item.sms) + " " + _toDisplayString(_unref(getUnits)("sms")), 1)
                  ])
                ]),
                (item.service.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(t)("tariff.page.unlimited")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(returnServiceIcons)(item.service), (img, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "tariff-change__item-unlimited--icon"
                          }, [
                            _createVNode(BaseIcon, {
                              name: img,
                              folder: "service",
                              "is-original-color": ""
                            }, null, 8, ["name"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(BaseButton, {
                      title: _unref(t)('common.actions.details'),
                      color: "grey",
                      size: "small",
                      onClick: ($event: any) => (_unref(tariffDetails)(item))
                    }, null, 8, ["title", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(BaseButton, {
                      title: _unref(t)('common.actions.connect'),
                      size: "small",
                      onClick: ($event: any) => (_unref(startChange)(item))
                    }, null, 8, ["title", "onClick"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(isDetailsTariff))
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("p", _hoisted_53, _toDisplayString(_unref(chosenTariff)?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", _hoisted_55, _toDisplayString(_unref(chosenTariff)?.price) + "₽ " + _toDisplayString(_unref(t)("common.labels.perMonth")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("p", _hoisted_58, _toDisplayString(_unref(chosenTariff).data) + " " + _toDisplayString(_unref(getUnits)("gb")), 1)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("p", _hoisted_60, _toDisplayString(_unref(chosenTariff).min) + " " + _toDisplayString(_unref(getUnits)("min")), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("p", _hoisted_62, _toDisplayString(_unref(chosenTariff).sms) + " " + _toDisplayString(_unref(getUnits)("sms")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("p", _hoisted_65, _toDisplayString(_unref(t)("tariff.page.unlimited")), 1)
            ]),
            _createElementVNode("div", _hoisted_66, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(returnServiceIcons)(_unref(chosenTariff).service), (img, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "tariff-details__unlimited--icon"
                }, [
                  _createVNode(BaseIcon, {
                    name: img,
                    folder: "service",
                    "is-original-color": ""
                  }, null, 8, ["name"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("a", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("p", _hoisted_70, _toDisplayString(_unref(t)("common.labels.offer")), 1),
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(BaseIcon, { name: "download" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createVNode(BaseButton, {
              title: _unref(t)('common.actions.connect'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(startChange)(_unref(chosenTariff) as TariffArray)))
            }, null, 8, ["title"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: ".root" }, [
      (_unref(modalsList).changeModal)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            title: 
          _unref(t)('tariff.details.connectTariffTitle', { name: _unref(chosenTariff)?.name })
        ,
            text: _unref(t)('tariff.details.connectTariffText'),
            "main-btn-title": _unref(t)('tariff.details.connectNow'),
            "secondary-btn-title": _unref(t)('tariff.details.connectLater'),
            onClose: _unref(closeModals),
            onAction: _cache[3] || (_cache[3] = ($event: any) => (_unref(doChange)('now'))),
            onSecondaryAction: _cache[4] || (_cache[4] = ($event: any) => (_unref(doChange)('later'))),
            "main-btn-loading": _unref(changeTariffNowLoading),
            "secondary-btn-loading": _unref(changeTariffLaterLoading)
          }, null, 8, ["title", "text", "main-btn-title", "secondary-btn-title", "onClose", "main-btn-loading", "secondary-btn-loading"]))
        : _createCommentVNode("", true),
      (_unref(modalsList).poorModal)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 1,
            title: _unref(t)('tariff.modals.insufficientFundsTitle'),
            "main-btn-title": _unref(t)('tariff.modals.insufficientFundsAction'),
            onClose: _unref(closeModals),
            onAction: _unref(toPayment)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(modalsList).commonError)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 2,
            title: _unref(t)('tariff.modals.connectionErrorTitle'),
            "main-btn-title": _unref(t)('tariff.modals.tryAgain'),
            onClose: _unref(closeModals),
            onAction: _unref(closeModals)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(modalsList).sameTariff)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 3,
            title: _unref(t)('tariff.modals.sameTariffTitle'),
            "main-btn-title": _unref(t)('tariff.modals.tryAgain'),
            onClose: _unref(closeModals),
            onAction: _unref(closeModals)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(modalsList).regionError)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 4,
            title: _unref(t)('tariff.modals.regionErrorTitle'),
            "main-btn-title": _unref(t)('tariff.modals.tryAgain'),
            onClose: _unref(closeModals),
            onAction: _unref(closeModals)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(modalsList).notFound)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 5,
            title: _unref(t)('tariff.modals.notFoundTitle'),
            "main-btn-title": _unref(t)('tariff.modals.tryAgain'),
            onClose: _unref(closeModals),
            onAction: _unref(closeModals)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(modalsList).noPlan)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 6,
            title: _unref(t)('tariff.modals.noPlanTitle'),
            "main-btn-title": _unref(t)('tariff.modals.tryAgain'),
            onClose: _unref(closeModals),
            onAction: _unref(closeModals)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(modalsList).successModal)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 7,
            title: _unref(t)('tariff.modals.successTitle'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _unref(closeModals),
            onAction: _unref(closeModals)
          }, null, 8, ["title", "main-btn-title", "onClose", "onAction"]))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})